import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ExpandLess, ExpandMore, MoreVert } from '@mui/icons-material';
import { Chip, Link, useMediaQuery } from '@mui/material';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import InfiniteScroll from '../../../builderPackage/components/infiniteScroll/infiniteScroll';
import { useAppSelector } from '../../../store/hooks';
import { dateFormate } from '../../../utils/utils';
import { ContractSaleOrderKeys } from '../../contractSaleOrder/services/entity';
import { PDICheckKeys } from '../services/entity';
// import { PDICheckPagingAPI } from '../services/apiCalls'
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { PDIChecPagingAPI } from '../services/apiCalls';
import { useNavigate } from 'react-router-dom';
var FailedTab = function (props) {
    var _crud$ContractSaleOrd, _crud$ContractSaleOrd2, _getLocalStorageItem, _getLocalStorageItem2;
    var value = props.value;
    var navigate = useNavigate();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var hasMore = !crud[ContractSaleOrderKeys.Paging] || ((_crud$ContractSaleOrd = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd === void 0 || (_crud$ContractSaleOrd = _crud$ContractSaleOrd.data) === null || _crud$ContractSaleOrd === void 0 ? void 0 : _crud$ContractSaleOrd.length) < ((_crud$ContractSaleOrd2 = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd2 === void 0 ? void 0 : _crud$ContractSaleOrd2.TotalCount);
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var shouldIncludeIdentityId = (value === null || value === void 0 ? void 0 : value.IdentityId) && value.IdentityId !== "all";
    // console.log('InspectorGivenName---', crud[PDICheckKeys?.Paging]?.data?.InspectorGivenName)
    var handleRowEditClick = function (id) {
        navigate("/createpdicheck/edit/".concat(id));
    };
    var columns = [{
            field: 'DocumentNo',
            headerName: 'Document no.',
            flex: 1,
            minWidth: 180,
            sortable: false
        }, {
            field: 'CreatedOn',
            headerName: 'Document date',
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedOn ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.CreatedOn)) : '-'; }
        }, {
            field: 'ModelName',
            headerName: 'Vehicle model',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'SerialNo',
            headerName: 'Engine no.',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'PinNo',
            headerName: 'VIN no.',
            flex: 1,
            minWidth: 150,
            sortable: false
        }, {
            field: 'InspectorName',
            headerName: 'Service advisor',
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueFormatter: function (val, row) {
                var _row$InspectorGivenNa, _row$InspectorFamilyN;
                return row !== null && row !== void 0 && row.InspectorGivenName || row !== null && row !== void 0 && row.InspectorFamilyName ? "".concat((_row$InspectorGivenNa = row === null || row === void 0 ? void 0 : row.InspectorGivenName) !== null && _row$InspectorGivenNa !== void 0 ? _row$InspectorGivenNa : ' ', "  ").concat((_row$InspectorFamilyN = row === null || row === void 0 ? void 0 : row.InspectorFamilyName) !== null && _row$InspectorFamilyN !== void 0 ? _row$InspectorFamilyN : ' ') : '-';
            }
        }, {
            field: 'TechnicianName',
            headerName: 'Technician',
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueFormatter: function (val, row) {
                var _row$TechnicianGivenN, _row$TechnicianFamily;
                return row !== null && row !== void 0 && row.TechnicianGivenName || row !== null && row !== void 0 && row.TechnicianFamilyName ? "".concat((_row$TechnicianGivenN = row === null || row === void 0 ? void 0 : row.TechnicianGivenName) !== null && _row$TechnicianGivenN !== void 0 ? _row$TechnicianGivenN : ' ', "  ").concat((_row$TechnicianFamily = row === null || row === void 0 ? void 0 : row.TechnicianFamilyName) !== null && _row$TechnicianFamily !== void 0 ? _row$TechnicianFamily : ' ') : '-';
            }
        }, {
            field: 'StatusName',
            headerName: 'PDI Status',
            flex: 1,
            minWidth: 120,
            sortable: false,
            renderCell: function (params) {
                var _params$value;
                return /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$value = params === null || params === void 0 ? void 0 : params.value) !== null && _params$value !== void 0 ? _params$value : '-',
                    size: "small",
                    variant: "filled",
                    color: "error",
                    shape: "square",
                    sx: {
                        borderRadius: 6,
                        px: 1,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    }
                });
            }
        }, {
            field: '-',
            headerName: 'Action',
            minWidth: 150,
            sortable: false,
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Link, {
                underline: "hover",
                component: 'button',
                onClick: function () {
                    var _params$row;
                    handleRowEditClick(params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.id);
                },
                fontSize: 'base',
                fontWeight: 'medium'
            }, " Start reinspection"); }
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentNo",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "CreatedOn",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.CreatedOn ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.CreatedOn)) : '-'; },
                                    // label: cardData.docNo,
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'sm',
                                        fontWeight: 'normal',
                                        color: 'secondary.900'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    // value: cardData?.statusName,
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'error',
                                    sx: {
                                        borderRadius: '6px',
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "menuIcon",
                                    color: 'secondary',
                                    size: 'small',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                                        color: "secondary"
                                    }),
                                    columnSize: 2,
                                    sx: {
                                        width: '18px',
                                        height: '18px'
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (state, currValue, field) {
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Service advisor: ',
                                    fontSize: 'base',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    valueGetter: function (val, row) {
                                        var _val$InspectorGivenNa, _val$InspectorFamilyN;
                                        return val !== null && val !== void 0 && val.InspectorGivenName || val !== null && val !== void 0 && val.InspectorFamilyName ? "".concat((_val$InspectorGivenNa = val === null || val === void 0 ? void 0 : val.InspectorGivenName) !== null && _val$InspectorGivenNa !== void 0 ? _val$InspectorGivenNa : ' ', "  ").concat((_val$InspectorFamilyN = val === null || val === void 0 ? void 0 : val.InspectorFamilyName) !== null && _val$InspectorFamilyN !== void 0 ? _val$InspectorFamilyN : ' ') : '-';
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PinNo',
                                    label: 'Vin no.: ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ModelName',
                                    label: 'Vehicle model no : ',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Technician : ',
                                    fontSize: 'base',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    valueGetter: function (val, row) {
                                        var _val$TechnicianGivenN, _val$TechnicianFamily;
                                        return val !== null && val !== void 0 && val.TechnicianGivenName || val !== null && val !== void 0 && val.TechnicianFamilyName ? "".concat((_val$TechnicianGivenN = val === null || val === void 0 ? void 0 : val.TechnicianGivenName) !== null && _val$TechnicianGivenN !== void 0 ? _val$TechnicianGivenN : ' ', "  ").concat((_val$TechnicianFamily = val === null || val === void 0 ? void 0 : val.TechnicianFamilyName) !== null && _val$TechnicianFamily !== void 0 ? _val$TechnicianFamily : ' ') : '-';
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        fontSize: 'sm',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    }
                                }]
                        };
                    },
                    elements: []
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            children: 'Start reinspection',
                            columnSize: 0,
                            color: 'primary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'base',
                                fontWeight: 'medium'
                            },
                            onClick: function (e, formValues, api) {
                                handleRowEditClick(formValues === null || formValues === void 0 ? void 0 : formValues.id);
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'base',
                                fontWeight: 'medium'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['View less', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, IS_DESKTOP ? /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        getPagingData: PDIChecPagingAPI,
        pagingAPIKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging,
        pagingAPIRequest: _objectSpread(_objectSpread({
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        }, shouldIncludeIdentityId && {
            IdentityId: value.IdentityId
        }), {}, {
            Status: "Fail"
        })
    }) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: PDIChecPagingAPI,
        apiKey: PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.Paging,
        apiRequest: _objectSpread(_objectSpread({
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId
        }, (value === null || value === void 0 ? void 0 : value.IdentityId) && (value === null || value === void 0 ? void 0 : value.IdentityId) !== "all" && {
            IdentityId: value === null || value === void 0 ? void 0 : value.IdentityId
        }), {}, {
            // IdentityId: value?.IdentityId == "all" ? null : value?.IdentityId,  //for my view
            Status: "Fail"
        }),
        elements: formData,
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2
        },
        gridItemProps: {
            xs: 12
        }
    }));
};
export default FailedTab;
